angular.module('elfium').directive('elfium', ['elfiumUrlService', function (elfiumUrlService) {
    return {
        restrict: 'E',
        scope: {},
        templateUrl: elfiumUrlService.getTemplateUrl('elfium')
    };
}]);


// WEBPACK FOOTER //
// ./src/app/components/elfium/elfium.ts